<script>
  import { get_previous_months } from "./OrSixChartUtils.svelte";
  import LeadFlow from "./LeadFlow.svelte";
  import BalkenProgressTable from "./BalkenProgressTable.svelte";
  import ActiveAnimalBalken from "./ActiveAnimalBalken.svelte";
  import {
    calc_activated_all_removed_not_new_cust_boli,
    calc_active_animals,
    calc_all_open_leads,
    calc_all_open_opps,
    calc_balken_progress_table_active_boli,
    calc_balken_progress_table_active_boli_from_events,
    calc_balken_progress_table_clients,
    calc_balken_progress_table_leads,
    calc_balken_progress_table_lost_boli,
    calc_balken_progress_table_lost_clients,
    calc_balken_progress_table_opps,
    calc_balken_progress_table_sold_boli,
    calc_lost_lead_number,
    calc_lost_opp_number,
    calc_months_last_year_array,
    calc_open_leads,
    calc_open_leads_per_month,
    calc_open_opps,
    calc_open_opps_per_month,
    calc_time_lead_to_customer,
    dateRange,
    dict_to_median,
    dict_to_sum,
    get_anteilsmaessig_date_filter_range,
    substract_dict,
    subtractYears,
  } from "./UtilsBalkenProgress.svelte";

  import { calc_astrid_table, get_field_if_exists } from "./UtilsNewDesign.svelte";
  import ZweiteTabelleAstridNeu from "./ZweiteTabelleAstridNeu.svelte";
  import {
    get_current_month_multiplicator,
    get_year_month_key,
    getLastDayOfMonth,
    getMonthDifference,
    percentage_math,
  } from "./Utils.svelte";

  let color_list = ["#51c3f9", "#44C1A3", "#37A76F", "#63A537", "#"];

  let mql_sources = [
    "Promotional Campaign: Leads",
    "Event",
    "Recommendation",
    "Webform - Request Quotation",
    "Social Media: Leads",
    "Incoming email",
    "Incoming Calls",
    "Webform - Call Back",
    "Webform - General Request",
    "Webform",
    "Webform - wants appointment",
    "Webform - WhatsApp",
    "Webform - contact reference farm",
    "Webinar participants ",
  ];

  var show = true;

  export let ytd_active;
  export let recalc = false;
  export let marketing_start_date;
  export let marketing_end_date;
  export let all_total_leads;
  export let res_partner_all;
  export let sale_order_all;
  export let marketing_goals;
  export let sales_goals;
  export let selected_timeframe_text;
  export let selected_timeframe_text_table;
  export let subscription_all;
  export let activated_all;
  export let helptexts;
  export let in_show_helptext_id;

  export let crm_lead_all;
  export let lost_leads;
  export let lost_opportunities;
  export let insights;
  export let archived;
  export let goals_all;
  export let messenger_res;

  export let laender_dict;
  export let source_cat_dict;

  export let include_dataimport = false;

  let conversion_time_median_lead_to_cust = 0;
  let conversion_time_median_lead_to_opp = 0;
  let conversion_time_median_opp_to_cust = 0;

  let lost_leads_filtered;
  let crm_lead_all_filtered;
  let lost_opportunities_filtered;
  let archived_filtered;

  let flow_numbers_dict = false;

  let marketing_keys;

  let months = [];

  let boli_target_key = "Boli Target";

  let mql_target = 3000;
  let opp_target = 500;
  let cus_target = 700;
  let boli_target = 50000;
  let acq_target;

  let active_animals = 1000;
  let active_animals_target = 0;

  let lead_target_percentage = 0;
  let cus_target_percentage = 0;
  let boli_target_percentage = 0;
  let lead_target_whole_year_percentage = 0;
  let cus_target_whole_year_percentage = 0;
  let boli_target_whole_year_percentage = 0;
  let opportunity_target_percentage = 0;
  let opportunity_target_whole_year_percentage = 0;

  let mql_target_whole_year;
  let opp_target_whole_year;
  let cus_target_whole_year;
  let boli_target_whole_year;
  let ACQCost_last_year;

  let act_new_leads = "";
  let act_new_clients = "";
  let act_sold_boli = "";
  let lost_new_leads = "";
  let aging_new_leads = "";
  let open_new_leads = "";
  let all_open_new_leads = "";
  let open_new_opps = "";
  let all_open_new_opps = "";
  let act_new_opportunities = "";
  let lost_new_opportunities = "";
  let aging_new_opportunities = "";
  let open_new_opportunities = "";
  let time_new_opportunities = "";

  let table_leads_dict;
  let table_opps_dict;
  let table_clients_dict;
  let table_lost_clients_dict;
  let table_sold_boli_dict;
  let table_active_boli_dict;
  let table_lost_boli_dict;
  let table_leads_basis;
  let table_opps_basis;
  let table_clients_basis;
  let table_sold_boli_basis;
  let table_active_boli_basis;
  let table_active_boli_deactivated_animals;
  let table_active_boli_new_boli_new_customers;

  let conversion_rate_lead_cust = 0;
  let conversion_rate_lead_opp = 0;
  let conversion_rate_opp_cust = 0;

  let nr_active_boli_calculated_from_messenger_events = 0;

  let left_overview;

  let zeilen = [
    { name: "% YTD", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "% Full-Year", daten: ["-", "-", "-", "-", "-", "-"] },
    { name: "Target (full-year)", daten: ["-", "-", "-", "-", "-", "-"] },
    { name: "Target (reporting timeframe)", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "Act (reporting timeframe)", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "Drop-out (%)", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "Aging (w)", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "Conversion Rate", daten: ["-", 2, 3, 5, 3, 1] },
    { name: "Open (current date)", daten: ["-", 2, 3, 5, 3, 1] },
  ];

  $: {
    recalc,
      lost_leads_filtered,
      crm_lead_all_filtered,
      lost_opportunities_filtered,
      archived_filtered,
      flow_numbers_dict,
      messenger_res,
      res_partner_all,
      lost_leads,
      lost_opportunities,
      activated_all,
      sale_order_all;

    if (
      lost_leads_filtered &&
      crm_lead_all_filtered &&
      lost_opportunities_filtered &&
      archived_filtered &&
      flow_numbers_dict &&
      messenger_res &&
      res_partner_all &&
      sale_order_all &&
      lost_opportunities &&
      lost_leads &&
      activated_all
    ) {
      months = calc_months_array();
      do_all_calculations();

      calc_balken_progress_table();
      bereits_in_flow_chart_berechnete_variablen_setzen();

      active_animals = calc_active_animals(res_partner_all, messenger_res, marketing_start_date, marketing_end_date, months, laender_dict);
      recalc = false;
    }
  }

  function calc_months_array() {
    var months = dateRange(marketing_start_date, marketing_end_date);

    return months;
  }

  function calc_balken_progress_table() {
    table_leads_dict = calc_balken_progress_table_leads(
      months,
      lost_leads,
      crm_lead_all,
      lost_opportunities,
      archived,
      marketing_start_date,
      marketing_end_date,
      source_cat_dict,
      laender_dict,
    );

    table_opps_dict = calc_balken_progress_table_opps(
      months,
      lost_leads,
      crm_lead_all,
      lost_opportunities,
      archived,
      marketing_start_date,
      marketing_end_date,
      source_cat_dict,
      laender_dict,
    );

    table_clients_dict = calc_balken_progress_table_clients(months, res_partner_all, laender_dict);

    table_lost_clients_dict = calc_balken_progress_table_lost_clients(months, res_partner_all, subscription_all, laender_dict);

    table_sold_boli_dict = calc_balken_progress_table_sold_boli(
      months,
      sale_order_all,
      marketing_start_date,
      marketing_end_date,
      laender_dict,
    );

    calc_balken_progress_table_active_boli(months, messenger_res, marketing_start_date, marketing_end_date, laender_dict);

    var active_boli = calc_balken_progress_table_active_boli_from_events(months, activated_all, laender_dict);

    // table_active_boli_dict = ret['new_animals'];
    table_active_boli_dict = active_boli;

    table_lost_boli_dict = calc_balken_progress_table_lost_boli(months, res_partner_all, subscription_all, laender_dict);

    // table_active_boli_deactivated_animals = ret['deactivated_animals'];
    table_active_boli_deactivated_animals = calc_balken_progress_table_active_boli_from_events(
      months,
      activated_all,
      laender_dict,
      "deactivated_",
    );

    var activated_all_removed_not_new_cust_boli = calc_activated_all_removed_not_new_cust_boli(activated_all);
    table_active_boli_new_boli_new_customers = calc_balken_progress_table_active_boli_from_events(
      months,
      activated_all_removed_not_new_cust_boli,
      laender_dict,
    );

    // FUnktion subtrahiert nur dicts und kann also auch hierfür verwendet werden
    substract_dict(months, table_active_boli_dict, table_active_boli_new_boli_new_customers);
    // FUnktion subtrahiert nur dicts und kann also auch hierfür verwendet werden
    substract_dict(months, table_active_boli_deactivated_animals, table_lost_boli_dict);

    // console.log('table_leads_dict: ', table_leads_dict);
    // console.log('table_clients_dict: ', table_clients_dict);
    // console.log("table_sold_boli_dict: ", table_sold_boli_dict)
    // console.log("table_active_boli_dict: ", table_active_boli_dict)

    var last_year_start = subtractYears(1, marketing_start_date);
    var last_year_end = subtractYears(1, marketing_end_date);
    var last_year_months = calc_months_last_year_array(last_year_start, last_year_end);

    var pre_month = new Date(marketing_start_date);
    pre_month.setMonth(pre_month.getMonth() - 1);
    var pre_months = calc_months_last_year_array(new Date(2016, 1, 1), pre_month);

    var table_leads_basis_dict = calc_balken_progress_table_leads(
      last_year_months,
      lost_leads,
      crm_lead_all,
      lost_opportunities,
      archived,
      last_year_start,
      last_year_end,
      source_cat_dict,
      laender_dict,
    );
    table_leads_basis = dict_to_median(table_leads_basis_dict);

    var table_opps_basis_dict = calc_balken_progress_table_opps(
      last_year_months,
      lost_leads,
      crm_lead_all,
      lost_opportunities,
      archived,
      last_year_start,
      last_year_end,
      source_cat_dict,
      laender_dict,
    );
    table_opps_basis = dict_to_median(table_opps_basis_dict);

    var table_clients_basis_dict = calc_balken_progress_table_clients(pre_months, res_partner_all, laender_dict);

    table_clients_basis = dict_to_sum(table_clients_basis_dict);

    var table_sold_boli_basis_dict = calc_balken_progress_table_sold_boli(
      last_year_months,
      sale_order_all,
      last_year_start,
      last_year_end,
      laender_dict,
    );
    table_sold_boli_basis = dict_to_median(table_sold_boli_basis_dict);

    calc_balken_progress_table_active_boli(pre_months, messenger_res, last_year_start, last_year_end, laender_dict);

    var active_boli_basis = calc_balken_progress_table_active_boli_from_events(pre_months, activated_all, laender_dict);

    var deactivated_boli_basis = calc_balken_progress_table_active_boli_from_events(
      pre_months,
      activated_all,
      laender_dict,
      "deactivated_",
    );

    // var table_active_boli_basis_dict = ret['active_animals'];
    var table_active_boli_basis_dict = active_boli_basis;

    //Here TODO active Boli changes
    // table_active_boli_basis = dict_to_sum(table_active_boli_basis_dict);
    table_active_boli_basis = dict_to_sum(table_active_boli_basis_dict) - dict_to_sum(deactivated_boli_basis);

    nr_active_boli_calculated_from_messenger_events =
      table_active_boli_basis +
      dict_to_sum(table_active_boli_dict) +
      dict_to_sum(table_active_boli_new_boli_new_customers) -
      dict_to_sum(table_active_boli_deactivated_animals) -
      dict_to_sum(table_lost_boli_dict);

    open_new_leads = calc_open_leads(
      crm_lead_all,
      lost_leads,
      lost_opportunities,
      archived,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );

    all_open_new_leads = calc_all_open_leads(
      crm_lead_all,
      lost_leads,
      lost_opportunities,
      archived,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );

    // console.log("all_open_new_leads: ", all_open_new_leads)

    open_new_opps = calc_open_opps(
      crm_lead_all,
      lost_opportunities,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );

    all_open_new_opps = calc_all_open_opps(
      crm_lead_all,
      lost_opportunities,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );
    // console.log("all_open_new_opps: ", all_open_new_opps)

    ////TODO nur kopiert macht noch nicht was es soll
    calc_open_opps_per_month(
      crm_lead_all,
      lost_opportunities,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );

    calc_open_leads_per_month(
      crm_lead_all,
      lost_leads,
      lost_opportunities,
      archived,
      months,
      laender_dict,
      source_cat_dict,
      marketing_start_date,
      marketing_end_date,
    );

    let open_leads_in_timeframe = all_open_new_leads;

    var lost_new_leads_number = calc_lost_lead_number(lost_leads, months, laender_dict, source_cat_dict);

    lost_new_leads = percentage_math(lost_new_leads_number, all_open_new_leads);

    var lost_opps_number = calc_lost_opp_number(lost_opportunities, months, laender_dict, source_cat_dict);

    // console.log('lost_opps_number: ', lost_opps_number);
    // console.log('dict_to_sum(table_opps_dict): ', dict_to_sum(table_opps_dict));
    // console.log('table_opps_dict: ', table_opps_dict);
    // console.log('all_open_new_opps: ', all_open_new_opps);
    // console.log("lost_new_leads: ", lost_new_leads)

    lost_new_opportunities = percentage_math(lost_opps_number, all_open_new_opps);

    var time_new_opportunities_days = calc_time_lead_to_customer(crm_lead_all, months, laender_dict, source_cat_dict);
    time_new_opportunities = (time_new_opportunities_days / 7).toFixed(1).toString() + "w";

    conversion_rate_lead_cust = percentage_math(dict_to_sum(table_clients_dict), open_leads_in_timeframe).toFixed(1);

    conversion_rate_lead_opp = percentage_math(dict_to_sum(table_opps_dict), open_leads_in_timeframe).toFixed(1);

    conversion_rate_opp_cust = percentage_math(dict_to_sum(table_clients_dict), all_open_new_opps).toFixed(1);

    // console.log("open_new_opps: ", open_new_opps)

    // console.log("table_leads_dict: ", table_leads_dict)
    // console.log("table_clients_dict: ", table_clients_dict)
    // console.log("table_sold_boli_dict: ", table_sold_boli_dict)
    // console.log("table_active_boli_dict: ", table_active_boli_dict)
    // console.log("table_leads_basis: ", table_leads_basis)
    // console.log("table_clients_basis: ", table_clients_basis)
    // console.log("table_sold_boli_basis: ", table_sold_boli_basis)
    // console.log("table_active_boli_basis: ", table_active_boli_basis)
    // console.log("table_active_boli_deactivated_animals: ", table_active_boli_deactivated_animals)
  }

  function bereits_in_flow_chart_berechnete_variablen_setzen() {
    // console.log('bereits_in_flow_chart_berechnete_variablen_setzen!');

    act_new_leads = flow_numbers_dict["New_LEADS"];
    act_new_clients = flow_numbers_dict["New_CUST"];
    act_sold_boli =
      flow_numbers_dict["EVT_New_Boli"] +
      flow_numbers_dict["ORG_New_Boli"] +
      flow_numbers_dict["ADV_New_Boli"] +
      flow_numbers_dict["SAL_New_Boli"];

    aging_new_leads = (flow_numbers_dict["Lead_Aging_Median"] / 7).toFixed(1).toString() + "w";

    act_new_opportunities = flow_numbers_dict["New_OPP"];
    aging_new_opportunities = (flow_numbers_dict["Opportunity_Aging_Median"] / 7).toFixed(1).toString() + "w";
    open_new_opportunities = flow_numbers_dict["Open"];

    conversion_time_median_lead_to_cust = flow_numbers_dict["Lead_To_Customer_Conversion_Time_Median"];
    conversion_time_median_lead_to_opp = flow_numbers_dict["Lead_To_Opportunity_Conversion_Time_Median"];
    conversion_time_median_opp_to_cust = flow_numbers_dict["Opportunity_To_Customer_Conversion_Time_Median"];

    lead_target_percentage = percentage_math(act_new_leads, mql_target);
    opportunity_target_percentage = percentage_math(act_new_opportunities, opp_target);
    cus_target_percentage = percentage_math(dict_to_sum(table_clients_dict), cus_target);
    boli_target_percentage = percentage_math(dict_to_sum(table_sold_boli_dict), boli_target);

    lead_target_whole_year_percentage = percentage_math(act_new_leads, mql_target_whole_year);
    opportunity_target_whole_year_percentage = percentage_math(act_new_opportunities, opp_target_whole_year);
    cus_target_whole_year_percentage = percentage_math(dict_to_sum(table_clients_dict), cus_target_whole_year);
    boli_target_whole_year_percentage = percentage_math(dict_to_sum(table_sold_boli_dict), boli_target_whole_year);
  }

  function do_all_calculations() {
    let all_leads_filtered = [];

    all_total_leads.forEach((element) => {
      let source = "";

      if (1 in element) {
        var obj = element[1];
        source = get_field_if_exists(obj, "source_id");
      } else {
        var obj = element;
        source = get_field_if_exists(obj, "x_source");
      }
      if (source != "Data Import" || include_dataimport) {
        all_leads_filtered.push(element);
      }
    });

    calc_marketing();
    sum_marketing_goals_over_time();

    left_overview = calc_astrid_table(all_leads_filtered, res_partner_all, sale_order_all, marketing_start_date, marketing_end_date);

    // "YTD"
    calc_astrid_table(all_leads_filtered, res_partner_all, sale_order_all, new Date(2022, 0, 1), new Date());

    // console.log("left_overview: ", left_overview)

    calc_table_values();
    calc_targets();
  }

  function get_is_checked(laender_dict, short) {
    var is_checked = false;

    laender_dict.forEach((land) => {
      if (land["short"] == short) {
        if (land["checked"]) {
          is_checked = true;
        }
      }
    });

    return is_checked;
  }

  function calc_targets() {
    var tmp_dict = {};

    laender_dict.forEach((land) => {
      tmp_dict[land["short"]] = {};
    });

    var sum_amt = 0;

    marketing_goals.forEach((goal) => {
      if (goal["challenge_name"].includes("AMS ")) {
        if (goal["goal_name"].includes("Cows")) {
          tmp_dict[goal["challenge_name"].split(" ")[1]]["AMS"] = goal["target_goal"];
        }
      }

      if (goal["challenge_name"].includes("AMT ")) {
        tmp_dict[goal["challenge_name"].split(" ")[1]]["AMT"] = goal["target_goal"];
        if (get_is_checked(laender_dict, goal["challenge_name"].split(" ")[1])) {
          if (goal["start_date"].substring(0, 4) == marketing_end_date.getFullYear().toString()) {
            sum_amt = sum_amt + goal["target_goal"];
          }
        }
      }
    });

    active_animals_target = sum_amt;
  }

  function calc_table_values() {}

  function get_marketing_keys() {
    let list_of_keys = [];
    marketing_goals.forEach((mg) => {
      var key = mg["challenge_name"];
      if (!list_of_keys.includes(key)) {
        list_of_keys.push(key);
      }
    });

    return list_of_keys;
  }

  function calc_marketing() {
    let marketing_goals_per_month = {};

    marketing_keys = get_marketing_keys();
    var months = get_previous_months(getMonthDifference(new Date("2020-05-01"), new Date()));

    marketing_keys.forEach((k) => {
      marketing_goals_per_month[k] = {};
      months.forEach((m) => {
        marketing_goals_per_month[k][m] = 0;
      });
    });

    // //console.log("months: ", months)
    // //console.log("marketing_goals: ", marketing_goals)

    marketing_goals.forEach((mg) => {
      if (mg["start_date"]) {
        var date_index = mg["start_date"].substring(0, 7);
        var target_goal = mg["target_goal"];
        var key = mg["challenge_name"];
        // //console.log("date_index: ", date_index)
        // //console.log("target_goal: ", target_goal)
        marketing_goals_per_month[key][date_index] += target_goal;
      }
    });

    // alle marketing goals bis 2020 0 erstellen

    // alles durchgehen und werte summieren

    // marketing_goals_per_month
  }

  function sum_marketing_goals_over_time() {
    let marketing_target_sums = {};
    let marketing_target_year_sums = {};

    marketing_target_sums[boli_target_key] = 0;
    marketing_target_sums[boli_target_key] = 0;

    marketing_target_year_sums[boli_target_key] = 0;

    marketing_keys.forEach((k) => {
      marketing_target_sums[k] = 0;
    });

    marketing_keys.forEach((k) => {
      marketing_target_year_sums[k] = 0;
    });

    get_year_month_key(new Date());
    get_current_month_multiplicator();

    var selected_year = marketing_start_date.getFullYear().toString();
    var selected_last_year = (marketing_end_date.getFullYear() - 1).toString();

    ACQCost_last_year = 0;

    marketing_goals.forEach((mg) => {
      if (!mg["start_date"]) {
        return;
      }

      var date_index = mg["start_date"].substring(0, 7);
      new Date(mg["start_date"]);
      var target_goal = mg["target_goal"];
      var key = mg["challenge_name"];

      if (
        mg["name"] == "SOLD_BOL_TARGET 2023 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2022 MKT" ||
        mg["name"] == "SOLD_BOL_TARGET 2021 MKT"
      ) {
        return;
      }

      //GESAMTES YEAR:
      if (date_index.substring(0, 4) == selected_year || date_index.substring(0, 4) == marketing_end_date.getFullYear().toString()) {
        marketing_target_year_sums[key] += target_goal;
      }

      if (
        (get_year_month_key(marketing_start_date).substring(0, 4) == selected_last_year ||
          get_year_month_key(marketing_end_date).substring(0, 4) == selected_year) &&
        key == "ACQCost"
      ) {
        ACQCost_last_year += target_goal;
      }

      let filter_end = marketing_end_date;

      // console.log("new Date(): ", new Date())
      if (ytd_active) {
        filter_end = getLastDayOfMonth(new Date());
        // console.log("change filter end: ", filter_end)
      }

      marketing_target_sums[key] += get_anteilsmaessig_date_filter_range(mg, months, marketing_start_date, filter_end);
    });

    mql_target = marketing_target_sums["LEAD_TARGET"];
    opp_target = marketing_target_sums["OPP_TARGET"];
    cus_target = marketing_target_sums["CUS_TARGET"];
    boli_target = marketing_target_sums["SOLD_BOL_TARGET"];

    // console.log('marketing_target_sums: ', marketing_target_sums);
    // console.log('bi_target: ', bi_target);

    mql_target_whole_year = marketing_target_year_sums["LEAD_TARGET"];
    opp_target_whole_year = marketing_target_year_sums["OPP_TARGET"];
    cus_target_whole_year = marketing_target_year_sums["CUS_TARGET"];
    boli_target_whole_year = marketing_target_year_sums["SOLD_BOL_TARGET"];
    acq_target = marketing_target_year_sums["ACQCost"];
  }
</script>

<div class="row haupt">
  <!-- <div class="col-md-6"><SankeyWrapper {data} /></div> -->

  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
    <div class="row">
      <div class="col-md-9 col-sm-9 col-lg-9 col-xl-9 col-xxl-9" style="padding-top:10px">
        {#if table_leads_dict && table_clients_dict && table_sold_boli_dict && table_opps_dict}
          <ZweiteTabelleAstridNeu
            bind:zeilen
            selected_year={marketing_start_date.getFullYear()}
            {marketing_end_date}
            {marketing_start_date}
            {selected_timeframe_text}
            {color_list}
            {source_cat_dict}
            {selected_timeframe_text_table}
            {lead_target_percentage}
            {opportunity_target_percentage}
            {cus_target_percentage}
            {boli_target_percentage}
            {lead_target_whole_year_percentage}
            {opportunity_target_whole_year_percentage}
            {cus_target_whole_year_percentage}
            {boli_target_whole_year_percentage}
            act_new_leads={dict_to_sum(table_leads_dict)}
            act_new_clients={dict_to_sum(table_clients_dict)}
            act_sold_boli={dict_to_sum(table_sold_boli_dict)}
            act_new_opportunities={dict_to_sum(table_opps_dict)}
            target_new_leads={mql_target}
            target_new_clients={cus_target}
            target_sold_boli={boli_target}
            total_target_new_leads={mql_target_whole_year}
            total_target_new_clients={cus_target_whole_year}
            total_target_sold_boli={boli_target_whole_year}
            {time_new_opportunities}
            {lost_new_leads}
            {aging_new_leads}
            open_new_leads={all_open_new_leads}
            open_new_opps={all_open_new_opps}
            {conversion_rate_lead_cust}
            {conversion_rate_lead_opp}
            {conversion_rate_opp_cust}
            target_new_opportunities={opp_target}
            total_target_new_opportunities={opp_target_whole_year}
            {lost_new_opportunities}
            {aging_new_opportunities}
            {conversion_time_median_lead_to_cust}
            {conversion_time_median_lead_to_opp}
            {conversion_time_median_opp_to_cust}
            {helptexts}
            {in_show_helptext_id}
          />
        {/if}
      </div>

      <div class="col-md-3 col-sm-3 col-lg-3 col-xl-3 col-xxl-3" style="padding-top:10px">
        <ActiveAnimalBalken
          {marketing_end_date}
          active_animals={nr_active_boli_calculated_from_messenger_events}
          {active_animals_target}
          {helptexts}
          {in_show_helptext_id}
        />
      </div>

      <div id="parent_of_balken_progress_table" class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
        <BalkenProgressTable
          {months}
          {source_cat_dict}
          {table_leads_dict}
          {table_opps_dict}
          {table_clients_dict}
          {table_lost_clients_dict}
          {table_sold_boli_dict}
          {table_active_boli_dict}
          {table_lost_boli_dict}
          {table_leads_basis}
          {table_opps_basis}
          {table_clients_basis}
          {table_sold_boli_basis}
          {table_active_boli_basis}
          {table_active_boli_deactivated_animals}
          {table_active_boli_new_boli_new_customers}
          {selected_timeframe_text}
          {helptexts}
          {in_show_helptext_id}
        />
      </div>
    </div>
  </div>

  <div class="col-md-12 col-sm-12 col-lg-12 col-xl-12 col-xxl-12" style="padding-top:10px">
    <div class="row">
      <div class="col">
        <LeadFlow
          {crm_lead_all}
          {lost_leads}
          {lost_opportunities}
          {archived}
          {marketing_start_date}
          {marketing_end_date}
          {selected_timeframe_text}
          sales_goals={goals_all}
          bind:lost_leads_filtered
          bind:crm_lead_all_filtered
          bind:lost_opportunities_filtered
          bind:archived_filtered
          bind:flow_numbers_dict
          bind:laender_dict
          bind:source_cat_dict
          {helptexts}
          {in_show_helptext_id}
        />
      </div>
    </div>
  </div>
</div>
